import { render, staticRenderFns } from "./viewLogistics.vue?vue&type=template&id=642c6d29&scoped=true"
import script from "./viewLogistics.vue?vue&type=script&lang=js"
export * from "./viewLogistics.vue?vue&type=script&lang=js"
import style0 from "./viewLogistics.vue?vue&type=style&index=0&id=642c6d29&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c6d29",
  null
  
)

export default component.exports